import { render, staticRenderFns } from "./BusinessClubMenu.vue?vue&type=template&id=06e6fa28&"
import script from "./BusinessClubMenu.vue?vue&type=script&lang=js&"
export * from "./BusinessClubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports